import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";
import DataTableComponent from "../../tools/DataTableComponent";
import * as Yup from "yup";
import { useFormik } from "formik";
import "../Validations/errors.css"

const baseUrl = process.env.REACT_APP_BASE_URL;
const token = localStorage.getItem("token");

export const validationSchema = Yup.object({
    nameLat: Yup.string()
        .required("Le nom est obligatoire")
        .min(2, "Minimum 2 caractères")
        .max(100, "Maximum 100 caractères"),

    nameAr: Yup.string()
        .max(100, "Maximum 100 caractères")
});


const Brand = () => {
    const [brands, setBrands] = useState([]);

    const initialValues = {
        id: 0,
        nameAr: "",
        nameLat: ""
    };

    const [selectedBrand, setSelectedBrand] = useState(null);

    useEffect(() => {
        fetchBrands();
    });

    const fetchBrands = () => {
        axiosInstance.get(`${baseUrl}/api/Brands`)
            .then(res => setBrands(res.data))
            .catch(() => console.log("Impossible de charger."));
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema,
        enableReinitialize: true,

        onSubmit: async (values, { setErrors }) => {
            try {
                const url = values.id
                    ? `${baseUrl}/api/Brands/UpdateBrand`
                    : `${baseUrl}/api/Brands/CreateBrand`;

                await axiosInstance.post(url, values);

                fetchBrands();
                resetForm();
                window.$("#modalForm").modal("hide");

                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Opération réussie",
                    showConfirmButton: false,
                    timer: 2000
                });
            } catch (err) {
                // étape G
                if (err.response?.data?.errors) {
                    setErrors(err.response.data.errors);
                } else {
                    Swal.fire("Erreur", "Erreur serveur", "error");
                }
            }
        }
    });

    const resetForm = () => {
        formik.resetForm();
        setSelectedBrand(null);
    };

    const handleEdit = (brand) => {
        setSelectedBrand(brand);
        formik.setValues(brand);

        setTimeout(() => {
            window.$("#modalForm").modal("show");
        }, 100);
    };


    const handleDelete = (id) => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance.post(`${baseUrl}/api/Brands/DeleteBrand`,
                    { 'id': id, 'idString': '' }
                )
                    .then(() => fetchBrands());
            }
        });
    };

    return (
        <div className="container-fluid mt-4">
            <h3 className="text-center my-3">Gestion des Marques</h3>
            {/* <button className="btn btn-primary mb-3" data-bs-toggle="modal" data-bs-target="#modalForm">Ajouter</button> */}
            <button className="btn btn-primary btn-ajouter mb-3" data-toggle="modal" data-target="#modalForm" onClick={resetForm}><i className="fas fa-plus"></i>Ajouter</button>

            <DataTableComponent
                data={brands}
                title="Liste des Marques"
                columns={["nameLat"]}
                columnsMapping={{
                    nameLat: "Nom"
                }}
                keyField="id"
                handleEdit={handleEdit}
                handleDelete={handleDelete}
            />

            {/* Modal Form */}
            <div className="modal fade" id="modalForm">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{selectedBrand ? "Modifier" : "Ajouter"} une Marque</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Nom</label>
                                <input
                                    type="text"
                                    name="nameLat"
                                    placeholder="Nom (Latin)"
                                    value={formik.values.nameLat}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className={`form-control mb-2 ${formik.touched.nameLat && formik.errors.nameLat ? "is-invalid" : ""
                                        }`}
                                />

                                {formik.touched.nameLat && formik.errors.nameLat && (
                                    <div className="invalid-feedback">
                                        {formik.errors.nameLat}
                                    </div>
                                )}

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-dismiss="modal" onClick={resetForm}>Annuler</button>
                            <button className="btn btn-primary" onClick={formik.handleSubmit}
                                disabled={formik.isSubmitting}>Sauvegarder</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Brand;
